export const moneyFormatter = (
  locale: string = 'es-CL',
  currency: string = 'CLP',
) => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
  });
};
